import { useIntl } from 'react-intl'

import { ButtonGroup, FormattedMessage } from '@subaio/components'

import type { OnLogEvent } from 'lib/container'

import { ButtonSolid, ButtonText } from 'components/Buttons'
import { Card } from 'components/Card'
import { IconLink } from 'components/Icons'
import { ButtonLabel, Header } from 'components/Layout'

import type { Handlers } from '../../handlers'
import { Title } from '../Title'

type Props = {
	onOpenUrl: (url: string) => void
	onLogScopedEvent: OnLogEvent
	onStepBack?: () => void
	onShowProductList: Handlers['onShowProductList']
}

export const ProductNotListed = ({ onOpenUrl, onLogScopedEvent, onStepBack, onShowProductList }: Props) => {
	const { formatMessage } = useIntl()

	return (
		<Card>
			<Header>
				<Title>
					<FormattedMessage
						id='opportunityCarInsurance.overview.modal.title'
						defaultMessage='Your car insurance is not listed'
					/>
				</Title>
				<p role='text'>
					<FormattedMessage
						id='opportunityCarInsurance.overview.modal.description'
						defaultMessage='Unfortunately, it is not possible to make a comparison without car insurance. Do you still want to know what ABN AMRO car insurance has to offer? '
					/>
				</p>
			</Header>
			<ButtonGroup spacing={8} center column>
				<ButtonSolid
					label={
						<ButtonLabel>
							<FormattedMessage
								id='opportunityCarInsurance.overview.modal.buttonCalculatePremium'
								defaultMessage='Calculate premium'
							/>
							<IconLink />
						</ButtonLabel>
					}
					aria-label={`
						${formatMessage({ id: 'opportunityCarInsurance.overview.modal.buttonCalculatePremium', defaultMessage: 'Calculate premium' })}.
						${formatMessage({ id: 'buttonExternal.annotation', defaultMessage: 'You are leaving the app and will be taken to the browser.' })}
					`}
					onClick={() => {
						onLogScopedEvent('CALCULATE_PREMIUM')
						onOpenUrl('https://www.abnamro.nl/mijn-abnamro/verzekeren/autoverzekering/aanvragen?pos=carefree_car')
					}}
				/>
				{onStepBack ? (
					<ButtonText
						label={<FormattedMessage id='opportunityCarInsurance.buttonBack' defaultMessage='Back' />}
						onClick={() => onStepBack()}
					/>
				) : (
					<ButtonText
						label={<FormattedMessage id='opportunityCarInsurance.buttonBack' defaultMessage='Back' />}
						onClick={() => onShowProductList()}
					/>
				)}
			</ButtonGroup>
		</Card>
	)
}
